import axios from "axios";

const API_URL = "https://api.fruitsweb3.xyz/api"; 

export const login = async (email, password) => {
  const response = await axios.post(`${API_URL}/login`, { email, password });
  return response.data;
};

export const logout = async () => {
  await axios.post(`${API_URL}/logout`, {}, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const checkAuth = async () => {
  const response = await axios.get(`${API_URL}/me`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response.data;
};
export const customersUpdate = async (wallet, ref) => {
  const response = await axios.post(`${API_URL}/customers/update`, { wallet, ref });
  return response.data;
};
export const nftUpdate = async (wallet) => {
  const response = await axios.post(`${API_URL}/nft/update`, { wallet });
  return response.data;
};
export const nftNumber = async () => {
  const response = await axios.post(`${API_URL}/nft/total`, {});
  console.log("nftNumber",response.data);
  return response.data;
};
export const customerschildren = async (wallet) => {
  const response = await axios.post(`${API_URL}/customers/children`, { wallet});
  console.log("customerschildren",response.data);
  return response.data;
};
export const getHomeSections = async () => {
  const response = await axios.get(`${API_URL}/home`, {});
  console.log("getHomeSections",response.data);
  return response.data;
};
export const getBlogs = async (page = 1) => {
  try {
    const response = await axios.post(`${API_URL}/blogs?page=${page}`, {}, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    console.log("getBlogs", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching blogs:', error);
    throw error;
  }
};
